/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Table_Last_Modified_HeaderInputs */

const en_explorer_table_last_modified_header = /** @type {(inputs: Explorer_Table_Last_Modified_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Modified`)
};

const fr_explorer_table_last_modified_header = /** @type {(inputs: Explorer_Table_Last_Modified_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derniere modification`)
};

const de_explorer_table_last_modified_header = /** @type {(inputs: Explorer_Table_Last_Modified_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Änderung`)
};

const it_explorer_table_last_modified_header = /** @type {(inputs: Explorer_Table_Last_Modified_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultima modifica`)
};

const ru_explorer_table_last_modified_header = /** @type {(inputs: Explorer_Table_Last_Modified_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последнее изменение`)
};

const es_explorer_table_last_modified_header = /** @type {(inputs: Explorer_Table_Last_Modified_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última modificación`)
};

const zh_cn2_explorer_table_last_modified_header = /** @type {(inputs: Explorer_Table_Last_Modified_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最后修改日期`)
};

const ja_explorer_table_last_modified_header = /** @type {(inputs: Explorer_Table_Last_Modified_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最終更新日`)
};

const hi_explorer_table_last_modified_header = /** @type {(inputs: Explorer_Table_Last_Modified_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंतिम बार संशोधित`)
};

const pt_pt2_explorer_table_last_modified_header = /** @type {(inputs: Explorer_Table_Last_Modified_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última modificação`)
};

/**
* | output |
* | --- |
* | "Last Modified" |
*
* @param {Explorer_Table_Last_Modified_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_last_modified_header = /** @type {((inputs?: Explorer_Table_Last_Modified_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Last_Modified_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_table_last_modified_header(inputs)
	if (locale === "de") return de_explorer_table_last_modified_header(inputs)
	if (locale === "it") return it_explorer_table_last_modified_header(inputs)
	if (locale === "ru") return ru_explorer_table_last_modified_header(inputs)
	if (locale === "es") return es_explorer_table_last_modified_header(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_table_last_modified_header(inputs)
	if (locale === "ja") return ja_explorer_table_last_modified_header(inputs)
	if (locale === "hi") return hi_explorer_table_last_modified_header(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_table_last_modified_header(inputs)
	return en_explorer_table_last_modified_header(inputs)
});